<template>
	<div id="departments">
		<el-card>
			<el-button plain size="small" @click="delChoseList" style="float: right;">新建文件夹</el-button>
			<el-table ref="filterTable" :data="tableData" style="width: 100%" @row-click="tablistClick">
				<el-table-column width="100">
					<template slot="header" slot-scope="scope">
						我的文件夹
					</template>
				</el-table-column>
				<el-table-column prop="tag" label="" width="30">
					<template slot-scope="scope">
						<i :class="scope.row.tag === '是' ? 'is-item' : 'is-folders'"></i>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="">
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<style scoped>
.is-folders {
	width: 20px;
	height: 20px;
	display: block;
	/* background-image: url(~@/assets/folders.jpg); */
	background-size: 100%;
}

.is-item {
	width: 20px;
	height: 20px;
	display: block;
	/* background-image: url(~@/assets/item.jpg); */
	background-size: 100%;
}
</style>

<script>
import axios from "axios";
export default {
	data() {

		return {
			tableData: [{
				name: "产品文档",
			}, {
				name: "设计文档",
			}, {
				name: "软件文档",
			}, {
				name: "工艺文档",
			}],

			tableData2: [{
				name: "成品说明书",
			}, {
				name: "物料规格说明书",
			}],

			tableData3: [{
				name: "电阻规格说明书",
				tag: "是"
			}, {
				name: "电容规格说明书",
				tag: "是"
			}],
		};
	},
	methods: {
		//点击编辑
		handleSelectionChange() {
			alert("1");
		},
		tablistClick(row, column, event) {
			//console.log(row);
			if (row.name == "产品文档") {
				this.tableData = this.tableData2;
			} else if (row.name == "成品说明书") {
				this.tableData = this.tableData3;
			} else if (row.name == "电阻规格说明书") {
				this.$router.push("/document");
			}
		},

	},
	created() {

	}
};
</script>
